import {Box, Paper, Typography} from "@mui/material";
import {useEffect, useState} from "react";

const ANIM_STEPS = [
    {
        desc: 'Clique em uma porta livre para iniciar a seleção.',
        states: Array(9).fill('livre'),
        cols: 3,
    },
    {
        desc: 'Porta selecionada. Passe o mouse para visualizar o retângulo.',
        states: ['first', 'livre', 'livre', 'livre', 'livre', 'livre', 'livre', 'livre', 'livre'],
        cols: 3,
    },
    {
        desc: 'Preview do retângulo aparece em azul.',
        states: ['first', 'preview', 'livre', 'preview', 'preview', 'livre', 'livre', 'livre', 'livre'],
        cols: 3,
    },
    {
        desc: 'Clique no canto oposto para confirmar o grupo.',
        states: ['grouped', 'grouped', 'livre', 'grouped', 'grouped', 'livre', 'livre', 'livre', 'livre'],
        cols: 3,
    },
    {
        desc: 'Numeração lógica atualiza: grupo vira porta 1, demais seguem.',
        states: ['grouped', 'grouped', 'livre', 'grouped', 'grouped', 'livre', 'livre', 'livre', 'livre'],
        cols: 3,
        labels: ['1', '—', '2', '—', '—', '3', '4', '5', '6'],
    },
    {
        desc: 'Retângulos maiores também funcionam (ex: 2×3).',
        states: ['grouped', 'grouped', 'grouped', 'grouped', 'grouped', 'grouped', 'livre', 'livre', 'livre'],
        cols: 3,
        labels: ['1', '—', '—', '—', '—', '—', '2', '3', '4'],
    },
    {
        desc: 'Clique em um grupo para desfazer o agrupamento.',
        states: Array(9).fill('livre'),
        cols: 3,
    },
];

const STATE_SX = {
    livre:   { background: '#e8f5e9', borderColor: '#81c784', color: '#1b5e20' },
    first:   { background: '#fff9c4', borderColor: '#f9a825', color: '#e65100' },
    preview: { background: '#e3f2fd', borderColor: '#64b5f6', color: '#0d47a1' },
    grouped: { background: '#e1e1e1', borderColor: '#656565', color: '#424242' },
    bloqueado: { background: '#ffcdd2', borderColor: '#ef9a9a', color: '#b71c1c' },
};

function AnimDoor({ state, label }) {
    const sx = STATE_SX[state] || STATE_SX.livre;

    return (
        <Box sx={{
            width: 28, height: 28, borderRadius: 1,
            border: `1.5px solid ${sx.borderColor}`,
            background: sx.background,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 10, fontWeight: 500, color: sx.color,
            transition: 'all .35s',
        }}>
            {label}
        </Box>
    );
}

export function TutorialLockerSecondStepPanel(props) {
    const [step, setStep] = useState(0);

    useEffect(() => {
        const t = setInterval(() => setStep(s => (s + 1) % ANIM_STEPS.length), 2200);
        return () => clearInterval(t);
    }, []);

    const s = ANIM_STEPS[step];

    return (
        <Box>
            <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '.05em' }}>
                Como agrupar
            </Typography>

            <Paper variant="outlined" sx={{ p: 1.5, mt: 1, mb: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, minHeight: 130, justifyContent: 'center' }}>
                <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${s.cols}, 28px)`, gap: '3px' }}>
                    {s.states.map((st, i) => (
                        <AnimDoor key={i} state={st} label={s.labels ? s.labels[i] : i + 1} />
                    ))}
                </Box>

                <Typography variant="caption" sx={{ textAlign: 'center', color: 'text.secondary', lineHeight: 1.5, minHeight: 36 }}>
                    {s.desc}
                </Typography>
            </Paper>

            <Box sx={{ display: 'flex', gap: .5, justifyContent: 'center', mb: 1.5 }}>
                {ANIM_STEPS.map((_, i) => (
                    <Box key={i} sx={{
                        width: 5, height: 5, borderRadius: '50%',
                        background: i === step ? '#1976d2' : '#bdbdbd',
                        transition: 'background .3s',
                    }} />
                ))}
            </Box>

            <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '.05em' }}>
                Passo a passo
            </Typography>

            <Box component="ol" sx={{ pl: 0, mt: 1, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: .8 }}>
                {[
                    'Clique na 1ª porta (qualquer canto do retângulo).',
                    'Passe o mouse — o preview aparece em azul.',
                    'Clique no canto oposto para confirmar.',
                    'A numeração lógica se atualiza automaticamente.',
                    'Clique no grupo para desfazer.',
                    'Pressione Esc para cancelar a seleção.',
                ].map((txt, i) => (
                    <Box key={i} component="li" sx={{ display: 'flex', gap: .8, alignItems: 'flex-start' }}>
                        <Box sx={{
                            width: 16, height: 16, borderRadius: '50%',
                            border: '0.5px solid', borderColor: 'divider',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 9, fontWeight: 500, flexShrink: 0, color: 'text.primary',
                        }}>
                            {i + 1}
                        </Box>

                        <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.5 }}>{txt}</Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}